<template>
  <AppRow>
    <TextField
      v-model="member.name"
      :label="nameLabel"
      :rules="[required]"
    />
    <CountrySelect
      v-if="hasBirthCountry"
      v-model="member.countryOfBirth"
      :label="countryLabel || $tt('birth_country')"
    />
  </AppRow>
</template>

<script setup lang="ts">
import type { FamilyMember } from '~/types';

defineProps<{
  nameLabel: string;
  hasBirthCountry?: boolean;
  countryLabel: string;
}>();

const member = defineModel<FamilyMember>({ required: true });

const { required } = useValidation();
</script>